import {
  type Cluster,
  type GetRealClustersResponse,
} from '@/packages/query-state/shared/types/clusters/ClustersResponse';

export function clustersSelector(data: GetRealClustersResponse): Cluster[] {
  return data.clusters;
}

export function nextZoomSelector(data: GetRealClustersResponse): number | undefined {
  return data.nextZoom;
}
